import axios from 'axios';
import { Component } from 'react';
import { setHeaderAuth, setHeaderIPv4 } from '../utils';

class ApiSurvey extends Component {
  static get = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys',
      method: 'post',
      data: data
    });

    return result;
  };
  static getSearch = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/search',
      method: 'post',
      data: data
    });

    return result;
  };
  static surveyGroupByProject = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/group',
      method: 'get',
    });
    return result;
  };
  static history = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/history',
      method: 'get',
    });
    return result;
  };
  static historyV2 = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/historyV2',
      method: 'get',
    });
    return result;
  };
  static favoriteHistory = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/favorite',
      method: 'get',
    });
    return result;
  };

  static favoriteHistoryProject = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: 'dga-user-service-survey/surveys/favoriteProject',
      method: 'get',
    });
    return result;
  };

  static getById = async ({ survey_id }) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/${survey_id}`,
      method: 'get',
    });
    return result;
  };

  static getByProjectId = async ({ project_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/project/${project_id}`,
      method: 'get',
    });
    return result;
  };

  static getContact = async ({ survey_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/contact/${survey_id}`,
      method: 'get',
    });
    return result;
  };

  static getDraftLaw = async ({ survey_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/draftLaw/${survey_id}`,
      method: 'get',
    });
    return result;
  };

  static getSummary = async ({ survey_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/summary/${survey_id}`,
      method: 'get',
    });
    return result;
  };

  static getQuestion = async ({ survey_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/question/${survey_id}`,
      method: 'get',
    });
    return result;
  };

  static getAnswer = async ({ answer_id }) => {
    const result = await axios({
      url: `dga-user-service-survey/surveys/answer/${answer_id}`,
      method: 'get',
    });
    return result;
  };

  static answer = async (data) => {
    await setHeaderIPv4();
    await setHeaderAuth();
    const result = await axios({
      url: `submit_survey/api/survey_uat`,
      method: 'post',
      data: data,
    });
    return result;
  };

  static cancelAnswer = async ({ id = 0 }) => {
    await setHeaderIPv4();
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/answer/${id}`,
      method: 'delete',
    });
    return result;
  };

  static answerDraft = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/answerDraft`,
      method: 'post',
      data: data,
    });
    return result;
  };

  static getAnswerDraft = async ({ id = 0 }) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/answerDraft/${id}`,
      method: 'get',
    });
    return result;
  };

  static getAnswerHistory = async ({ id = 0 }) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/answerHistory/${id}`,
      method: 'get',
    });
    return result;
  };

  static viewSurvey = async ({ id = 0 }) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/view/${id}`,
      method: 'get',
    });
    return result;
  };


  static favorite = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/favorite`,
      method: 'post',
      data: data,
    });
    return result;
  };

  static favoriteProject = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: `dga-user-service-survey/surveys/favoriteProject`,
      method: 'post',
      data: data,
    });
    return result;
  };
}

export default ApiSurvey;
